export default "__VITE_ASSET__Kavwbri5__"